import { ACTION_RICH_MENU_CONDITION_SETTING } from './actions'
import { IRichMenuRequest, IRichMenuConditionSetting } from '@/utils/types'
import { apiListChangedHandler } from '@/utils/helpers'
import richMenuConditionSettingApi from '@/api/richMenuConditionSetting'
import cloneDeep from 'lodash/cloneDeep'
import { localStore } from '@/utils/localstore'
import { constant } from '@/utils/constants'

type TState = {
  items: IRichMenuConditionSetting[]
  loading: boolean
}

export default {
  state: {
    items: [],
    loading: false,
  },
  getters: {
    richMenuSettings: (state: TState) => {
      return state.items as IRichMenuConditionSetting[]
    },
  },
  mutations: {
    // [New item]
    [ACTION_RICH_MENU_CONDITION_SETTING.SET_NEW_ITEM]: (state: TState, { item }: { item: IRichMenuConditionSetting }) => {
      state.items = apiListChangedHandler<IRichMenuConditionSetting>(state.items, cloneDeep(item), 'added')
    },

    // [UPDATE]]
    [ACTION_RICH_MENU_CONDITION_SETTING.SET_UPDATED_ITEM]: (state: TState, { item }: { item: IRichMenuConditionSetting }) => {
      state.items = apiListChangedHandler<IRichMenuConditionSetting>(state.items, cloneDeep(item), 'modified')
    },
  },
  actions: {
    // eslint-disable-next-line
    [ACTION_RICH_MENU_CONDITION_SETTING.LOAD_ITEM]: async ({ commit }, params: IRichMenuRequest) => {
      const resp = await richMenuConditionSettingApi.single(params)
      return resp
    },
    [ACTION_RICH_MENU_CONDITION_SETTING.ADD]: async ({ commit }, payload: IRichMenuConditionSetting) => {
      const resp = await richMenuConditionSettingApi.add(payload)
      if (resp?._id) {
        commit(ACTION_RICH_MENU_CONDITION_SETTING.SET_NEW_ITEM, { item: resp })
        return resp
      }
    },
    [ACTION_RICH_MENU_CONDITION_SETTING.UPDATE]: async ({ commit }, payload: IRichMenuConditionSetting) => {
      const resp = await richMenuConditionSettingApi.update(payload)
      if (resp?._id) {
        commit(ACTION_RICH_MENU_CONDITION_SETTING.SET_UPDATED_ITEM, { item: resp })
        return resp
      }
    },
    // eslint-disable-next-line
    [ACTION_RICH_MENU_CONDITION_SETTING.IS_ACTIVE]: async ({ commit }, payload: IRichMenuConditionSetting) => {
      const resp = await richMenuConditionSettingApi.active(payload)
      if (resp?._id) {
        localStore.removeStartsWith(constant.LOCAL_KEYS.RICH_MENUS + payload.app_id)
        commit(ACTION_RICH_MENU_CONDITION_SETTING.SET_UPDATED_ITEM, { item: payload })
        return true
      }

      return false
    },
  },
}
